import { createContext } from 'react'

export interface AiPassphraseRecoveryContextValue {
  isRecoverable: boolean
  isRecovering: boolean
  setIsRecovering: (isRecovering: boolean) => void
}

export const AiPassphraseRecoveryContext = createContext<AiPassphraseRecoveryContextValue>(
  undefined as unknown as AiPassphraseRecoveryContextValue,
)
